export { default as emojiIndex } from './utils/emoji-index/emoji-index';
export { default as NimbleEmojiIndex } from './utils/emoji-index/nimble-emoji-index';
export { default as store } from './utils/store';
export { default as frequently } from './utils/frequently';
export { getEmojiDataFromNative } from './utils';

export { default as Picker } from './components/picker/picker';
export { default as NimblePicker } from './components/picker/nimble-picker';
export { default as Emoji } from './components/emoji/emoji';
export { default as NimbleEmoji } from './components/emoji/nimble-emoji';
export { default as Category } from './components/category';


//////////////////
// WEBPACK FOOTER
// ./~/emoji-mart/dist-es/index.js
// module id = 298
// module chunks = 2